import React from 'react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <div className="pt-12 pb-20 md:pt-20 md:pb-32" data-id="element-21">
      <Section className="text-center md:text-left" data-id="element-22">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-23">
          <div className="flex-1 space-y-8" data-id="element-24">
            <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-brown font-bold" data-id="element-25">
              No te falta disciplina. <br data-id="element-26" />
              <span className="text-terracotta" data-id="element-27">
                Te falta un plan para días malos.
              </span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-brown/90 leading-relaxed" data-id="element-28">
              <p data-id="element-29">Hay un tipo de cansancio que no se quita durmiendo.</p>
              <p data-id="element-30">
                Es el cansancio de arrastrarte por la semana… mientras te dices
                que "ahora sí" vas a ser constante.
              </p>
              <p data-id="element-31">Y lo peor no es el cansancio.</p>
              <p data-id="element-32">
                Lo peor es esa culpa silenciosa:{' '}
                <span className="italic" data-id="element-33">
                  "¿Por qué yo no puedo sostener nada?"
                </span>
              </p>
            </div>

            <div className="pt-4" data-id="element-34">
              <a href="#oferta" className="inline-block w-full md:w-auto" data-id="element-35">
                <Button className="w-full md:w-auto group" data-id="element-36">
                  Quiero mi Reset — $6.36 USD
                  <span className="ml-2 text-cream/60 line-through text-base" data-id="element-37">
                    $19.00
                  </span>
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-38" />
                </Button>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md mx-auto md:max-w-none" data-id="element-39">
            <div className="relative" data-id="element-40">
              <div className="absolute inset-0 bg-terracotta/10 rounded-3xl rotate-3 transform scale-95" data-id="element-41" />
              <img src="https://cdn.magicpatterns.com/uploads/1qSJmLuRrj24iVViJipter/reset_4_pilares_mockup.png" alt="Reset 4 Pilares en móvil" className="relative rounded-2xl shadow-2xl transform transition-transform hover:scale-[1.02] duration-500" data-id="element-42" />
            </div>
          </div>
        </div>
      </Section>
    </div>;
}